import React from 'react'
import {Field} from "react-final-form";

// resources
import { setNarrowDown } from '~/data/shop/itemSearchOption'

// components
import RenderRadioButton from '~/components/finalForms/atoms/RenderRadioButton'

export const SetCategoryField = React.memo(() => {
  return(
      <div>
        <div>
          <Field
              id="setCategory"
              name="setCategory"
              labels={setNarrowDown.setCategory.map((category) => category.label)}
              vals={setNarrowDown.setCategory.map((category) => category.code)}
              component={RenderRadioButton}
              row='true'
          />
        </div>
      </div>
  )
})

SetCategoryField.displayName = 'SetCategoryField'
